// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import config from '../assets/empresas/taxi_directo/configuraciones/config.json'
import configuration from '../assets/empresas/taxi_directo/configuraciones/configuration.json'
export const environment = {
  production: true,

  URL_BASE: 'https://portal.directoapp.pe/integration_prod/api/',

  URL_BASE_WSNEXUS: 'https://portal.directoapp.pe/wsnexusconductormovil_3_0_0/api/',

  URL_BASE_CLIENTE: 'https://portal.directoapp.pe/wsnexusclientemovil_4_0_0_RF/api/',

  URL_INTRANET:'https://portal.directoapp.pe/intranet/',

  URL_INDICADORES: 'https://portal.directoapp.pe/integration-indicadores/api/',

  URL_ADMIN:'https://portal.directoapp.pe/admin-dev/',

  URL_PAYU: 'https://portal.directoapp.pe/ServicioPayu/api/',
  //URL_PAYU: 'https://directo.nexusvirtual.net/ServicioPayuDesarrollo/api/',

  URL_VISANET: 'https://portal.directoapp.pe/PASARELA_VISA/api/',
  // URL_GET_COUNTRY: 'https://ipinfo.io',
  URL_REPORTE: 'https://portal.directoapp.pe/integracion_reportes/',
  //URL_REPORTE: 'https://reporte-directo.nexusvirtual.net/reporte-directo/',
  //URL_REPORTE: 'https://reporte-directo.nexusvirtual.net/reporte-directo-desarrollo/',

  //URL_EMAIL: 'https://portal.directoapp.pe/integration-email-test/api/',
  URL_EMAIL: 'https://portal.directoapp.pe/integration-email/api/',

  URL_MAP_SERVICE: 'https://portal.directoapp.pe/map-service-web/api/direction/',

  URL_TRACKING: 'https://portal.directoapp.pe/integracion_tracking/',
  versionCheckURL: 'https://portal.directoapp.pe/intranet/version.json',
  URL_CONDUCTOR: '',
  VERSION: '6.5.1',
  IDIOMA: 'es',
  LOGO: {
    URL: 'assets/empresas/taxi_directo/img/logos/logo-empresa-menu.png',
    ALT: 'logo-taxi-directo',
    WIDTH : 80
  },
  LOGO_MENU: {
    FLAG: false,
    URL: '',
    ALT: 'logo-taxi-directo',
    WIDTH : 80
  },
  LOGO_INICIO_SESION: {
    URL: 'assets/empresas/taxi_directo/img/logos/logo-empresa.png',
    ALT: 'logo-taxi-directo'
  },
  IMAGEN_USUARIO_URL: 'assets/empresas/taxi_directo/img/usuario.png',

  IMAGEN_SESION_1: {
    URL: 'assets/empresas/taxi_directo/img/logos/logo-empresa-menu_alterna.png',
    ALT: 'img-senñor-taxi'
  },
  IMAGEN_SESION_2: {
    URL: 'assets/empresas/taxi_directo/img/logos/imagen-logo-2-png',
    ALT: 'img-senñor-taxi'
  },
  COLOR_RUTA: "#008efb",
  COLOR_RUTA_2: "#0A50E8",
  COLOR_RUTA_CONDUCTOR:"#f31616d7",
  COLOR_RUTA_CONDUCTOR_2: "#00afe9",
  COLOR: {
    PRIMARY: "#00529C",
    SECONDARY: "#ffffff",
    KM: "#ffffff"
  },
  ICON_BUSQUEDA: {
    ORIGEN: {
      URL: 'assets/empresas/taxi_directo/img/busqueda/origen.png',
      ALT: 'imagen-origen'
    },
    DESTINO: {
      URL: 'assets/empresas/taxi_directo/img/busqueda/destino.png',
      ALT: 'imagen-destino'
    },
    REFERENCIA: {
      URL: 'assets/empresas/taxi_directo/img/markers/referencia.png',
      ALT: 'imagen-referencia'
    },
    INSTRUCCION: {
      URL: 'assets/empresas/taxi_directo/img/markers/instruccion.png',
      ALT: 'imagen-instruccion'
    },
    ICONO_TIEMPO: {
      URL: 'assets/empresas/atras-en-el-tiempo.svg',
      ALT: 'imagen-tiempo'
    },
  },
  TEST: 'assets/empresas/taxi_directo/img/busqueda/destino.png',
  MARKERS: {
    ORIGEN: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker-origen.png',
      URL_2: 'assets/empresas/taxi_directo/img/markers/marker-origen-2.png',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(30, 30)
    },
    DESTINO: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker-destino.png',
      URL_2: 'assets/empresas/taxi_directo/img/markers/marker-destino-2.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(30, 30)
    },
    ORIGENTRACKING: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker-origen-tracking.png',
      POSICION: 1,
      ICON_SIZE: new google.maps.Size(10, 10)
    },
    DESTINOTRACKING: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker-destino-tracking.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(30, 30)
    },
    TRAYECTO: {
      URL: 'assets/empresas/taxi_directo/img/markers/punto.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(20, 20)
    },

    CONTACTO: {
      URL: 'assets/empresas/taxi_directo/img/markers/simple_Icon.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    VELOCIDAD: {
      URL: 'assets/empresas/bym_taxi/img/markers/pin.png',
      POSICION: 2,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    CONDUCTOR: {
      URL: 'assets/empresas/taxi_directo/img/markers/conductor.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(56, 56)
    },
    CONDUCTOR_AUTO_LIBRE: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_verde.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_AUTO_SINGPS: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_gris.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_AUTO_OCUPADO: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_rojo.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_MOTO_LIBRE: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_verde.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_MOTO_SINGPS: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_gris.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    CONDUCTOR_MOTO_OCUPADO: {
      URL: 'assets/empresas/taxi_directo/img/markers/marker_rojo.png',
      POSICION: 3,
      ICON_SIZE: new google.maps.Size(48, 48)
    },
    DRIVER: {
      CARRO_DEFECTO: {
        URL: 'assets/empresas/taxi_directo/img/markers/ic_driver_top.png',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },
      MOTO: {
        URL: 'assets/empresas/taxi_directo/img/tipo-autos/moto.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },
      AUTO: {
        URL: 'assets/empresas/taxi_directo/img/tipo-autos/auto.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },
      MINIVAN: {
        URL: 'assets/empresas/taxi_directo/img/tipo-autos/minivan.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },
      CAMIONETA: {
        URL: 'assets/empresas/taxi_directo/img/tipo-autos/camioneta.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },
      STATION_WAGON: {
        URL: 'assets/empresas/taxi_directo/img/tipo-autos/station-wagon.svg',
        POSICION: 3,
        ICON_SIZE: new google.maps.Size(56, 56)
      },


    },

  },
  REPORTES_PERSONALIZADO_PDF: {
    HABILITADO: false,
    NOMBRE: 'LevelTaxiReporte'
  },
  ESTADO: {
    ASIGNADO: 2,
    LEIDO: 3,
    CONTACTO: 5,
    INICIO: 6,
    TERMINADO: 7,
    LLEGO_DESTINO: 14,
    CANCELADO: 10,
    LIBRE: 1,
    PENDIENTE: 12,
    RECHAZADO: 9,
    OCUPADO: 15,
    FIN_JORNADA: 13,
    PREASIGNADO: 21,
    ANULADO1: 8,
    ANULADO2: 9,
    ANULADO3: 10,
    SIN_SENIAL: -1,
    BUSCANDO: 20,
    EMPALME: 16
  },
  MODO_RESERVA: {
    BASE: 1,
    APLICATIVO: 2,
    WEB_API: 3,
    WEB: 4,
    COMUNIDAD: 5
  },
  TIPO_PAGO: {
    VALE: 1,
    EFECTIVO: 2,
    ABONO: 4,
    E_VALE: 6,
    TARJETA: 7,
    CORTESIA: 20,
    TIKECK_COUNTER: 21
  },
  TIPO_SERVICIO: {
    MOTO: 10,
    POR_TIEMPO: 5
  },
  TIEMPO_CONSULTAR_RUTA: 10000,
  MENSAJES: {
    CAMPOS_DINAMICOS: {
      NO_INGRESADOS: 'Necesario ingresar Campos Dinámicos'
    },
    KILOMETRAJE: {
      NO_CALCULADO: 'No se ha calculado la cantidad de kilómetros',
    },
    CONFIGURACION_PARAMETROS: {
      MSJ_ACTUALIZACION: 'Su información se actualizo correctamente',
      MSJ_NO_EXISTE_PARAMETRO: ' No existe el parámetro: '
    },
    COMPARTIR_SERVICIO: {
      MSJ_SERVICIO_NO_ENCONTRADO: "NO SE ENCONTRÓ EL SERVICIO.",
      MSJ_SERVICIO_LIBRE: "Servicio creado",
      MSJ_SERVICIO_ASIGNADO: "Su conductor está en camino",
      MSJ_SERVICIO_INICIO: "Está en camino",
      MSJ_SERVICIO_TERMINO: "Llegó a su destino"
    },
    SOLICITAR_SERVICIO: {
      MSJ_SERVICIO_CREADO: "Servicio creado correctamente.",
      MSJ_ERROR_DESCONOCIDO: "Ocurrio un problema, por favor intente nuevamente.",
      MSJ_SIN_PRESUPUESTO: "No cuenta con Presupuesto.",
      MSJ_VALIDACION_HORARIO: "No se puede realizar el servicio en el horario indicado.",
      MSJ_PRESUPUESTO_INACTIVO: "Presupuesto inactivo, elegir otro tipo de pago.",
      MSJ_EMPRESA_INACTIVA: "Empresa inactiva.",
      MSJ_EMPRESA_PRESUPUESTO_INACTIVO: "Empresa - Presupuesto Inactivo.",
      MSJ_CENTRO_COSTO_INACTIVO: "Centro Costo Inactivo.",
      MSJ_CENTRO_COSTO_PRESUPUESTO_INACTIVO: "Centro Costo - Presupuesto Inactivo.",
      MSJ_PRESUPUESTO_INACTIVO_CLIENTE: "Cliente - Presupuesto Inactivo.",
      MSJ_PRESUPUESTO_PLAZO_INCORRECTO: "El plazo solicitado es incorrecto, máximo 2 días de anticipación.",
      MSJ_NOTA_OBLIGATORIA: "El campo Nota 1 es obligatirio.",
      MSJ_USUARIO_NO_ENCONTRADO: "No se encontraron usuarios",
      MSJ_EMPRESA_NO_ENCONTRADA: "No se encontraron Empresas",
      MSJ_CC_NO_ENCONTRADO: "No se encontraron Centros de Costos",
      MSJ_AREAS_NO_ENCONTRADA: "No se encontraron Áreas o Subáreas",
      MSJ_ZONAS_NO_ENCONTRADA: "No se encontraron Zonas de tiempo de reserva",
      MSJ_TRACKING_NO_ENCONTRADO: "No se encontró el tracking del conductor",
      MSJ_CUPONES_NO_ENCONTRADO: "No se encontró registro de cupones.",
      MSJ_AGREGAR_TARJETA: "NO DISPONE DE UNA TARJETA, AGREGUE PARA PEDIR UNA ORDEN",
      MSJ_PEV_NO_ENCONTRADO: "No se encontró registros",
    },
    CANCELAR_SERVICIO: {
      MSJ_CANCELAR_SERVICIO: "Búsqueda cancelada por usuario.",
      MSJ_CANCELAR_SERVICIO_ENVIOS: "El servicio fue cancelado correctamente."
    },
    SEDES: {
      MSJ_SEDE_NO_ENCONTRADA: "No se encontraron Sedes"
    },
    DIRECCION_FAVORITA: {
      DIRECCION_GUARDADA: "Se agregó la dirección favorita exitosamente",
      DIRECCION_NO_GUARDADA: "No se ha logrado guardar la dirección exitosamente",
      DIRECCION_AÑADIDA:"Se añadió a la ruta la dirección favorita",
      DIRECCION_BORRADA:"Se eliminó la dirección favorita correctamente",
      DIRECCION_ENBLACO:"No has ingresado ninguna dirección en el campo",
      NOMBREFAVORITO_ENBLANCO:"No has ingresado un nombre para tu dirección favorita"
    },
    FORMULARIO_CONDUCTOR:{
      OK_MESSAGE : "Registro Exitoso!",
      WARNING_MESSAGE_CAMPO_MOTIVO :"Seleccione un Campo Motivo",
      WARNING_MESSAGE_CAMPO_TIENDA :"Seleccione una tienda/cliente",
      LABEL_BUTTON_ATRAS : "Atrás",
      LABEL_BUTTON_ACEPTAR : "Aceptar"
  },
    LOGIN: {
      USUARIO_INACTIVO: {
        CODIGO: -201,
        DESCRIPCION: 'Usuario inactivo'
      },
      NO_EXISTE_USUARIO: {
        CODIGO: -203,
        DESCRIPCION: 'No existe usuario'
      },
      CLAVE_INCORRECTA: {
        CODIGO: -202,
        DESCRIPCION: 'Contraseña incorrecta'
      },

      CLAVE_NO_ESTABLECIDA: {
        CODIGO: -204,
        DESCRIPCION: 'Contraseña no establecida'
      },
      ERROR: {
        CODIGO: -1,
        DESCRIPCION: 'Ocurrio un error'
      },
      CORREO_CORPORATIVO: {
        CODIGO: 1,
        DESCRIPCION: 'Correo enviado correctamente. Por favor revise su bandeja de entrada'
      },
      RECUPERAR_CONTRASENIA: {
        CODIGO: 1,
        DESCRIPCION: 'Recibirá en unos momentos un mensaje en su correo electrónico, para recuperar su contraseña.'
      },
      CAMBIAR_TELEFONO: {
        CODIGO: 1,
        DESCRIPCION: 'Recibirá en unos momentos un mensaje en su correo electrónico, para cambiar su teléfono.'
      },
      CORREO_DUPLICADO: {
        CODIGO: -6,
        DESCRIPCION: 'Su correo ya ha sido registrado'
      },
      CORREO_SIN_ACCESOS: {
        CODIGO: -999,
        DESCRIPCION: 'Usted no tiene accesos a la web'
      },
      USUARIO_NO_RELACIONADO: {
        CODIGO: -206,
        DESCRIPCION: 'Usted no está relacionado a la empresa'
      },
      USUARIO_NO_ASIGNADO: {
        CODIGO: -207,
        DESCRIPCION: 'Usted no tiene asignado una empresa'
      },
      PARTICULAR_DESACTIVADO: {
        CODIGO: -208,
        DESCRIPCION: 'Parece que estás intentando usar un canal equivocado. Ingresa a tu usuario desde el app de Directo, en tu teléfono Android o iOS.'
      },
      ACTUALIZAR_CLAVE: {
        CODIGO: -209,
        DESCRIPCION: 'Es necesario que cambies tu contraseña para reforzar la seguridad de cuenta. Actualízala por favor.'
      },
      PRIMERA_SESION: {
        CODIGO: -210,
        DESCRIPCION: 'Es necesario que cambies tu contraseña para reforzar la seguridad de cuenta. Actualízala por favor.'
      }

    },

    ENVIOS: {
      MSJ_SIN_CONDUCTOR: "No se pudo obtener coordenadas del conductor.",
      MSJ_SIN_SERVICIOS: "No se encontraron servicios",
      MSJ_CALIFICACION_ESTRELLAS: "Se calificó correctamente al conductor.",
      MSJ_SERVICIOS_POR_CALIFICAR: "Tienes servicios por calificar, puede realizarlo desde 'Ver servicios'.",
      ERROR: {
        ERROR_CALIFICACION_ESTRELLAS: "Ocurrió un error al calificar; por favor intente mas tarde.",
      }
    },
    OCURRIO_PROBLEMA: {
      CODIGO: -1,
      DESCRIPCION: 'Ocurrio un problema, por favor intente nuevamente.'
    },
    METODO_PAGO: {
      TARJETA_CREADA: 'Se ha registrado su tarjeta correctamente',
    },
    PROMOCIONES: 'Validación exitosa',
    SERVICIOS_ENVIADOS: 'Servicios enviados correctamente',
    ZONA_PELIGROSA: 'Recojo en zona con Alta Siniestralidad por Robo reportada por las autoridades. Un operador lo llamará minutos antes del servicio para coordinar un recojo seguro.',
    FORMAT_EXCEL: 'EL Formato Excel es Incorrecto'
  },
  PROVIDER:
  {
    CULQI: 1,
    PAYU: 0,
    VISANET: 3
  },
  ROL:
  {
    ADMIN: 1,
    PARTICULAR: 3,
    ADMIN_CORPORATIVO: 5,
    CORPORATIVO: 6,
    ASISTENTE_CORPORATIVO: 15,
    SUPERVISOR: 13,
    OWNER: -2
  },
  SOLICITAR_MULTIPUNTO: {
    MSJ_CLEAR_RUTA: "Solicitar Servicio: No  ha ingresado los campos requeridos.",
    MSJ_LISTA_MARKERS_VACIA: "No ha ingresado el dato de destino.",
    MSJ_USUARIO_TELEFONO: "Ingrese un numero telefono.",
    MSJ_TIPO_PAGO: "Seleccione un tipo de pago.",
    MSJ_DETALLE_ENVIO: "Describa su envio.",
    MSJ_CONTACTO_NOMBRE: "Ingrese el nombre del contacto.",
    MSJ_CONTACTO_TELEFONO: "Ingrese el telefono del contacto.",
    MSJ_NO_OBTUVO_CONDUCTOR: "No se encontro conductor.",
    MSJ_MINIMO_LENGTH: "Numero de celular Incorrecto.",
    MSJ_REGISTER_TARJETA: "Su tarjeta ha sido registrada exitosamente",
    MSJ_REGISTRAR_TARJETA: "Por favor espere unos minutos mientras se registra su tarjeta",
    MSJ_TIPO_SERVICIO: "Seleccione un tipo de servicio.",
    MSJ_ID_PASAJERO: "Seleccione un personal de la empresa.",
    MSJ_TELEFONO_PASAJERO: "Ingrese un celular del personal de la empresa.",
    MSJ_LINEA_AEREA: "Ingrese la línea aérea.",
    MSJ_NRO_VUELO: "Ingrese el numero de vuelo.",
    MJ_LISTA_PERSONAL: "Espere un momento, la lista de personal se esta cargando.",
    MSJ_NO_PERSONAL: "No se encuentran resultados.",
    MSJ_NO_HA_SELECCIONADO_FECHAS: 'Seleccione fecha para el servicio de rutina',
    MSJ_NO_INGRESO_CAMPOS_DINAMICOS: 'El dato de los campos dinamicos requeridos aun no ha sido ingresado',
    MSJ_NO_CENTRO_COSTO: 'No se seleccionó un Centro de Costo',
    ERROR: {
      USUARIO_INACTIVO: 'El usuario esta inactivo',
      CONSURTAR_TARIFA: 'Ocurrio un error, Por favor intente mas tarde.',
      CREAR_SERVICIO: 'Ocurrio un error, Por favor cree un servicio nuevamente.',
      OBTENER_CONDUCTOR: 'Ocurrio un error, Por favor volver a realizar la consulta.',
      CANCELAR_SERVICIO: 'Ocurrio un error, No se pudo cancelar el servicio.',
      TIPO_PAGO: 'Ocurrio un error, Por favor recargar la pagina.',
      TIPO_PAGO_EMPTY: 'Usted no tiene ningun tipo de pago registrado.',
      TIPO_SERVICIO_EMPTY: 'Usted no tiene ningun tipo de servicio registrado.',
      LST_PERSONAL: 'Ocurrio un error, Al cargar la lista del personal.',
      LST_SEDES: 'Ocurrio un error, Al cargar la lista las Sedes',
      LST_CENTRO_COSTO_EDITABLE: 'Ocurrio un error, Al cargar los Centros de Costos.',
      SIN_PRESUPUESTO: "No cuenta con Presupuesto",
      SIN_DIRECCION: "No se encontró la dirección ingresada",
      VALIDACION_HORARIO: "No se puede realizar el servicio en el horario indicado",
      PRESUPUESTO_INACTIVO: "Presupuesto inactivo, elegir otro tipo de pago",
      EMPRESA_INACTIVA: "Empresa inactiva",
      EMPRESA_PRESUPUESTO_INACTIVO: "Empresa - Presupuesto Inactivo",
      CENTRO_COSTO_INACTIVO: "Centro Costo Inactivo",
      CENTRO_COSTO_PRESUPUESTO_INACTIVO: "Centro costo - Presupuesto Inactivo",
      PRESUPUESTO_INACTIVO_CLIENTE: "Cliente - Presupuesto Inactivo",
      SIN_TARIFA: "No se pudo obtener la tarifa para la ruta ingresada",
      SERVICIO_FECHA_RESERVA_MINIMA: "La fecha seleccionada no cumple con el tiempo minimo de reserva. ",
      PRESUPUESTO_PLAZO_INCORRECTO: "El plazo solicitado es incorrecto, máximo 2 días de anticipación",
      NOTA_OBLIGATORIA: "El campo Nota 1 es obligatorio",
      ERROR_RUTINA_SERVICIOS: "Hubo un inconveniente al crear los servicios, con las fechas: ",
      ERROR_CONDUCTORES_CERCANOS: 'Ocurrio un error al obtener conductores cercanos, Por favor intente mas tarde.',
    }
  },
  TIPO_EMAIL: {
    NINGUNO: 0,
    NUEVO_CLIENTE: 1,
    FIN_SERVICIO: 2,
    RECUPERAR_CONTRASENIA: 4
  },
  ENVIOS: {
    HABILITAR_TRAZADO: true,
    CONSULTA_ENVIOS: 20000,
    FLAG_LABEL_TELEFONO_CONDUCTOR: true,// solo movicab false
    ACTIVAR_TIEMPO_LLEGADA_CONDUCTOR : true, // true directo y cargui
    ACTIVAR_TIEMPO_RUTA: false, // solo true para cargui
    TIEMPO_LLEGADA_CONDUCTOR : false // solo cargui

  },
  COMPARTIR_SERVICIO: {
    HABILITAR_TRAZADO: true,
    HABILITAR_TRAZADO_CONDUCTOR: true,//true solo directo

  },
  MENU: {
    SOLICITAR_SERVICIO: 1,
    USUARIOS: 2,
    ENVIOS: 3,
    METODOS_PAGO: 4,
    MI_EMPRESA: 5,
    MI_CUENTA: 6,
    CERRAR_SESION: 7,
    CENTRO_COSTO: 8
  },
  URL_TIENDA: {
    ANDROID: 'https://play.google.com/store/apps/details?id=com.nexusvirtual.client.taxidirectocliente',
    IMG_ANDRIOD: '',
    IOS: 'https://apps.apple.com/pe/app/directo/id1234410357',
    IMG_IOS: ''
  },
  APPIDFB: '310329426412429',
  INICIO_FB: true,
  FOTO_ESTRELLA: 'assets/estrellaConductor.png',
  API_KEY_GOOGLE: 'AIzaSyDY7VttluV-5aKp3fWm8L0gsWMC7b_0jlk',
  OPTIMIZEWAYPOINTS: false,
  SHOWPOLIGONO: false,
  MULTIDESTINO: true,
  EMPRESA: {
    PARTICULAR: 1
  },
  CENTRO_COSTO: {
    PARTICULAR: 2196
  },
  CENTRO_COSTO_TERCERO: {
    ACTIVO: false,
  },
  OPCIONES_DESARROLLO: true
  ,
  CODIGO_PROMOCIONAL: {
    MONEDA_LOCAL: 1,
    PORCENTAJE: 2
  },
  COUNTRY_DEV: {
    HABILITADO: false,
    PAISES: {
      BOLIVIA: {
        HABILITADO: false,
        COORD: {
          LAT: -17.787699,
          LNG: -63.185270
        },
        CODE: 'BO'
      },
      CHILE: {
        HABILITADO: false,
        COORD: {
          LAT: -33.431866,
          LNG: -70.609325
        },
        CODE: 'CL'
      },
      MEXICO: {
        HABILITADO: true,
        COORD: {
          LAT: 19.1788445,
          LNG: -96.2113356
        },
        CODE: 'MX'
      },
      COSTA_RICA: {
        HABILITADO: true,
        COORD: {
          LAT: 9.935697,
          LNG: -84.1484506
        },
        CODE: 'CR'
      }, EC: {
        HABILITADO: true,
        COORD: {
          LAT: -2.1662649,
          LNG: -79.921618
        },
        CODE: 'EC'
      }
    }
  },
  CONF_PAIS: {
    PAISES: {
      BOLIVIA: {
        RUC: 'NIT',
        DNI: 'C.I. (Cédula de identidad)',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'BO'
      },
      CHILE: {
        RUC: 'RUT',
        REFERENCIA: 'Calle y número, Oficina / Piso, Comuna ,Ciudad',

        CODE: 'CL',

      },
      PERU: {
        RUC: 'RUC',
        DNI: 'DNI',
        REFERENCIA: 'Añada un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'PE'

      },
      MEXICO: {
        RUC: 'RFC',
        DNI: 'INE',
        REFERENCIA: 'Añana un Psj, Dpto, interior, piso, Mz Lt',
        CODE: 'MX'
      },
      EC: {

        DNI: 'C.I. (Cédula de identidad)',
        CODE: 'EC'
      },
      COSTA_RICA: {
        DNI: 'C.I. (Cédula de identidad)',
        CODE: 'CR'
      }
    }
  },
  NOMBRE_EMPRESA: 'Directo',
  PAGINACION: 5,
  PASARELA_PAGO: {
    CULQI: false,
    PAYU: false,
    VISANET: true,
    OPENPAY: false,
    OPENPAY_MERCHANT_ID: 'momgjkw3kuo80j584dge',
    OPENPAY_PUBLIC_KEY: 'pk_07276db5c8664cfdbb9faeb9da61da05',
    OPENPAY_SANDBOX: false
  },
  /* CONFIGURACIONES_PASARELAS :{
     VISANET :{
       MERCHANT_ID:  "342062522",
       endPointJS: "https://static-content-qas.vnforapps.com/vTokenSandbox/js/checkout.js",
       endPointSecurity: "https://static-content-qas.vnforapps.com/vToken/js/checkout.js",
       endPointSession: "https://apisandbox.vnforappstest.com/api.ecommerce/v2/ecommerce/token/session/",
       endPointAuthorization: "https://apisandbox.vnforappstest.com/api.authorization/v3/authorization/ecommerce/",
       currency: "PEN",
       channel: "web",
       user: "integraciones@niubiz.com.pe",
       pwd: "_7z3@8fF",
       ruta_nexus : "https://directo.nexusvirtual.net/intranet-niubiz/default/metodo-pago/tarjeta" //http://localhost:4200/default/metodo-pago/tarjeta
     }
   },*/
  CONFIGURACIONES_PASARELAS: {
    VISANET: {
      MERCHANT_ID: "VISA_API_MERCHANT_ID_WEB",
      endPointJS: "https://static-content-qas.vnforapps.com/vToken/js/checkout.js",
      endPointSecurity: "https://static-content-qas.vnforapps.com/vToken/js/checkout.js",
      endPointSession: "VISA_API_URL_TOKEN",
      endPointAuthorization: "https://apitestenv.vnforapps.com/api.authorization/v3/authorization/ecommerce/",
      currency: "PEN",
      channel: "web",
      user: "VISA_API_USERNAME",
      pwd: "VISA_API_PASSWORD",
      ruta_nexus: "https://directo.nexusvirtual.net/intranet-niubiz/default/metodo-pago/tarjeta" //http://localhost:4200/default/metodo-pago/tarjeta

    }
  },
  COLOR_ESTADO: {
    LIBRE: '#00e676',
    ASIGNADO: '#FF9800',
    LEIDO: '#ff5252',
    CONTACTO: '#5c6bc0',
    INICIO: '#3D5afe',
    LLEGO_DESTINO: '#ef9a9a',
    PENDIENTE: '#26a69a',
    RECHAZADO: '#D50000',
    OCUPADO: '#4c535a',
    FIN_JORNADA: '#21252921',
    PREASIGNADO: '#dc561d',
    ANULADO: '#adb5df',
    SIN_SENIAL: '#e4c2e0',
    BUSCANDO: '#ffff00'
  },
  CENTER_MAP_COMPARTIR: {
    LAT: -12.1251109,
    LNG: -76.9928316,
    CITY: 'Salamanca',
    COUNTRY: "PE",
    LOC: "-12.0833,-77.0000",
    REGION: "Lima",
  },
  TARIFA_FORMA_CALCULO: {
    VALUE: 3,
    TEXT: "Tarifa pactada Cliente- Conductor"
  },

  MONEDA: '(S/)',

  DOCUMENTO_FISCAL: {
    NOMBRE: 'RUC',
    DESCRIPCION: 'Razon Social'
  },
  CALIFICAR: {
    ACTIVO: true
  },
  TEXTOS_ENVIOS: {
    PLACA: 'Económico',
    MONEDA: '$',
    VEHICULO: 'Vehículo',

  },

  APROBACIONES: {
    MSJ_APROBADO: 'El servicio fue aprobado.',
    MSJ_RECHAZADO: 'El servicio fue rechazado.',
    MSJ_APROBADO_ANTERIORMENTE: 'El servicio fue aprobado anteriormente.',
    MSJ_RECHAZADO_ANTERIORMENTE: 'El servicio fue rechazado anteriormente.',
    MSJ_FECHA_EXPIRO: 'La fecha del servicio expiró.'
  },
  URL_FOTO_REPORTE: {
    URL: 'https://portal.directoapp.pe/',
    VALE: 'PhotoVale/',
    PEAJE: 'PhotoPeaje/',
    TEMPERATURA: 'https://assets-sanborja.s3.amazonaws.com/FotoConductor/'
  },
  REGISTRO_USUARIO: true,
  OLVIDE_CONTRASENIA: true,
  TEXTO_SOLICITAR: {
    RESERVA: 'Reserva',
    INMEDIATO: 'Inmediato'
  },
  FLAG_SERVICIO_RUTINA: false,
  TIEMPO_SESION: {
    HABILITAR: true,
    TIEMPO: 120,
    PING: 60,
    TIMEOUT: 3600
  },
  COUNTRY: 'PE',
  REPORTES_PERSONALIZADO: {
    HABILITADO: true,
    NOMBRE: 'TaxiDirectoReporte'
  },
  CONSULTAR_CONDUCTORES: true,
  ESTADO_CONDUCTORES: {
    SINGPS: 0,
    LIBRES: 1,
    OCUPADO: 2
  },
  TIPO_VEHICULO_MAPS: {
    MOTO: 1,
    AUTO: 2
  },
  //MOTO
  ISMOVICAB: false,
  ICONS: {
    MOTO: false,
    GAS : false
  },
  MENU_VER_SERVICIOS: {
    VISUALIZAR_ICONO : {
        MOTO : true,
        CARRO : true,
        GAS : false
    },
    OCULTAR_REFIN : false,
    OCULTAR_REFERENCIA : false
},
  FLAG_COUNTRY_REGISTRO: false,
  SHOW_CONTAINER_REFIN: false,
  SHOW_CONTAINER_REFERENCIA: false,
  OBSERVACION: true,
  DATOS_CONTACTO: false,
  DATELLE_SERVICIO: true,
  ORIGEN_SERVICIO:true,//
  DESTINO_SERVICIO:true,// false solo en cargui
  SHOW_DATA_CONTACTO: false,
  DEFAULT_TIPO_PAGO_SERVICIO: true,
  FLAG_SERVICIO_RETORNO: true,
  SHOW_TIPO_VEHICULO: false,
  //END MOTO
  //AEROPUERTO
  FLAG_AIRPORT: false,
  TIPO_VUELO: true,
  FAVORITOS:true, // SOLO DIRECTO EN TRUE
  //END AEROPUERTO
  //TRAKING
  URL_FOTO_CONDUCTOR: 'https://portal.directoapp.pe/Photo/',
  URL_NOTIFICACIONES: 'https://portal.directoapp.pe/',
  PATH_TRACKING: '/integracion_tracking/socket.io/',

  TRUNC_DECIMAL: false,
  RUTA_DEFAULT: 'solicitar-servicio',
  FLAG_CLIENTE_ENCARGO: false,
  VERTRACKING: false,

  COMPANIA: false,
  VERIFICARDATOS: false,
  //PERSONALIZACION LABELS
  LABELS_PERSONALIZACION: config,
  CONFIGURATION :configuration,
  VALIDACIONES_SOLICITAR: {
    TRUNCAR_TOTAL_SERVICIO: false, // MOVICAB TRUE
    RETORNO_ULTIMO_DESTINO: false, //taxi_directo TRUE
    FLAG_RETORNO_RESERVA_INEDIATO: false, // solo CARGUI TRUE
    ULTIMO_DESTINO_TARIFAR_COMO_PRIMER_DESTINO: false, //SOLO MOVICAB TRUE
    INSTRUCCION_DESTINO: false,//taxi_directo TRUE
    REFERENCIA_DESTINO: false,//taxi_directo TRUE
    CONTACTO_ADICIONAL: false,//taxi_directo TRUE
    AEROPUERTO_COMBO_NACIONAL_INTER: true, //DIRECTO TRUE
    AEROPUERTO_DETALLES_VUELO: false,
    SELECCIONAR_TIPO_PAGO_DEFECTO: true,//taxi_directo FALSE
    TIPO_VEHICULO: 'AUTO', //taxi_directo MOTO
    SOLICITAR_SERVICIO_RUTINA: true, //LEVEL,DIRECTO TRUE
    LISTAR_CODIGO_PROMOCIONAL: false, //TODOS FALSE
    MODAL_VERIFICACION_DATOS_SERVICIO: true,// SOLO LEVEL TRUE
    OCULTARKM: false, //SOLO MOLINA TRUE
    CELULAR_CONTACTO: true, //TODOS TRUE
    OBSERVACION: true, //SOLO NIREX FALSE
    SERVICIO_INMEDIADO: true, //NIREX FALSE
    AÑADIR_TARJETA: true, // SOLO NIREX
    DISPONE_TARJETA: false,// solo nirex
    FLAG_GA: false,// solo nirex
    LISTA_PAGO_X_SERVICIO: true, //solo directo
    FLAG_RESPUESTA: false, // solo nirex
    TIPO_PAGO_NIREX_DEFAULT: false, // solo nirex
    CONTACTO_X_MOTO: false, // solo level
    HIDE_TOTAL_SERVICIO: true, // solo guaria
    CONTACTO_X_COURIER: false,//solo level
    CANTIDAD_DESTINOS: 6 ,// normal 6 , nirex solo 8
    ACTIVAR_SEDES_MODAL_CARGA  : false , //solo para altoke
    ACTIVAR_ICONO_VERSERVICIOS_GAS : false ,
    CALCULAR_CANTIDAD_KM : false ,// solo taxicorporativo
    ACTIVAR_ANCHO_CAJAS_SOLICITAR_SERVICIO : false, // true solo en cargui
    ACTIVAR_INMEDIATO_RESERVA_DESPACHADOR_AUTOMATICO: true, // true en CARGUI, DIRECTO, SR-TAXI
    MARKERS_CON_INFO_EN_MODAL:true,//treu solo directo
    FLAG_ANULAR_SERVICIO_INMEDIATO: true, // solo false en Remisse 21
    CAMPODINAMICO:{
      EFECTIVO:false // true en cargui
    },
    FLAG_COLECTIVO_WEB: true, // true solo en directo
    VALIDAR_PEDIR_PARA_OTROS: true, //true solo en directo
  },
  VALIDACION_OWNER: {
    DIAS_DESCUENTO: false, //solo ivancar true
    MONTO_DESCUENTO: false, // solo ivancar true
    TOTAL_INCREMENTO_MONTO : false ,// solo somara true
    TIEMPO_ESTIMADO_ENTREGA : false ,// solo cargui true
    TIEMPO_EDICION : true,// cargui false
    FLAG_ACTIVACION_VISUALIZAR_TARIFA : false,// somara true
    FLAG_EMVIO_CORREO_FINALIZACION_SUPERVISOR:true, // solo directo en true
    FLAG_ACTIVO_DESES:false //treu solo cargi
  },
  VALIDACION_AGREGARUSUARIO:{
    HABILITAR_CAMPOS_CODIGO : true  // TRUE solo directo
  },
  CENTRO_COSTO_AREA: {
    COMBO: false // solo para taxsat
  },
  TARIFA_X_BLOQUE: {
    ACTIVADO: false // solo para nirex
  },
  PROVEEDOR_PASARELA: 3,
  DELIVERY: false,
  CODCLIENTE: 'NXVDIRECTO',
  POINT_GOOGLE_ANALYTICS: '',
  ICONO_TIPOSERVICIO: {
    URL_0: 'assets/empresas/liligas/img/markers/balon2.svg',
    URL_1: 'assets/empresas/liligas/img/markers/balon2.svg',
    URL_AUTO:'',
    URL_FURGON:'',
    URL_CAMION:'',
    URL_REFRIGERADO:'',
    ALT: 'logo-liligas'
  },
  MOSTRAR_PROPINA : true ,// solo true para directo
  TIPO_REPORTE: [
    {
        id: 0,
        tipo: "Cupones",
        filtros: {
            idConductor: true,
            tipoAsistencia: true,
            fechaInicio : true,
            fechaFin : true,
        }
    },
    {
      id: 1,
      tipo: "ReportePventa",
      filtros: {
          idConductor: true,
          tipoAsistencia: true,
          fechaInicio : true,
          fechaFin : true,
      }
  },
  {
    id: 2,
    tipo: "ReportePropina",
    filtros: {
        idConductor: true,
        idServicio:true,
        fechaInicio : true,
        fechaFin : true,
    }
}
],

  ACTUALIZAR_DISEÑO_MONITOREO : false, // solo para cargui true
  MONITOREO_CONDUCTORES : {
  BACKGROUND_COLOR : 'red',
  COLOR : 'white'
},
USUARIO :{
  ACTIVAR_AREA : false // solo sr taxi true
},
TEMEOUT_ALERT_MESSAGE:3700,
VALIDAR_GRUPO_NEGOCIO:{
  ACTIVO:false, // ACTIVO EN TRUE SOLO ALO45 Y MITAXI
  IDGRUPONEGOCIO : 0
}
};
/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
